/* Taksh Luxe — product-page interactions, loaded only on product templates. */
(function () {
  'use strict';

  function publishCustomEvent(name, data) {
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;
    try {
      var result = analytics.publish('taksh_luxe:' + name, data || {});
      if (result && typeof result.catch === 'function') result.catch(function () {});
    } catch (error) {}
  }

  var enquirySuccess = document.querySelector('[data-availability-enquiry-success]');
  if (enquirySuccess) {
    publishCustomEvent('availability_enquiry_submitted', {
      productId: enquirySuccess.getAttribute('data-product-id') || '',
      variantId: enquirySuccess.getAttribute('data-variant-id') || ''
    });
  }

  function pauseExternalVideo(frame) {
    try {
      var url = new URL(frame.src, window.location.href);
      var host = url.hostname.toLowerCase();
      if (host === 'www.youtube.com' || host === 'www.youtube-nocookie.com') {
        frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), url.origin);
      } else if (host === 'player.vimeo.com') {
        frame.contentWindow.postMessage({ method: 'pause' }, url.origin);
      }
    } catch (error) {}
  }

  var mobileGalleryQuery = window.matchMedia('(max-width: 899px)');

  function showMedia(mediaId) {
    var id = String(mediaId || '');
    var stage = document.querySelector('[data-media-stage]');
    if (!stage) return;
    var gallery = stage.parentElement;
    var target = null;
    var mobileMode = mobileGalleryQuery.matches;
    stage.querySelectorAll('[data-media-item]').forEach(function (item) {
      var active = item.getAttribute('data-media-item') === id;
      if (active) target = item;
      if (!active && !item.hidden) {
        item.querySelectorAll('video').forEach(function (video) { video.pause(); });
        item.querySelectorAll('iframe').forEach(pauseExternalVideo);
        item.querySelectorAll('model-viewer').forEach(function (model) {
          if (typeof model.pause === 'function') model.pause();
        });
      }
      /* On mobile all items are visible in a scroll snap strip; keep them
         mounted so scroll navigation works. */
      item.hidden = mobileMode ? false : !active;
    });
    if (!target) return;
    gallery.querySelectorAll('[data-media-thumb]').forEach(function (thumbnail) {
      var selected = thumbnail.getAttribute('data-media-thumb') === id;
      thumbnail.setAttribute('aria-pressed', String(selected));
      if (selected && typeof thumbnail.scrollIntoView === 'function') {
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        thumbnail.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
      }
    });
    if (mobileMode && typeof target.scrollIntoView === 'function') {
      var reducedMotionM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reducedMotionM ? 'auto' : 'smooth', inline: 'start', block: 'nearest' });
    }
  }

  /* Mobile: as the user swipes the plate, mark the corresponding dot active. */
  function setupMobileGalleryObserver() {
    var stage = document.querySelector('[data-media-stage]');
    if (!stage || !('IntersectionObserver' in window)) return;
    var items = stage.querySelectorAll('[data-media-item]');
    if (items.length <= 1) return;
    var observer = new IntersectionObserver(function (entries) {
      if (!mobileGalleryQuery.matches) return;
      entries.forEach(function (entry) {
        if (entry.intersectionRatio < 0.6) return;
        var id = entry.target.getAttribute('data-media-item');
        var gallery = stage.parentElement;
        gallery.querySelectorAll('[data-media-thumb]').forEach(function (thumbnail) {
          thumbnail.setAttribute('aria-pressed', String(thumbnail.getAttribute('data-media-thumb') === id));
        });
      });
    }, { root: stage, threshold: [0.6] });
    items.forEach(function (item) { observer.observe(item); });
  }

  /* Click-to-zoom: open the current media in a fixed overlay. */
  function setupZoom() {
    var stage = document.querySelector('[data-media-stage]');
    if (!stage) return;
    var overlay = null;
    function ensureOverlay() {
      if (overlay) return overlay;
      overlay = document.createElement('div');
      overlay.className = 'pdp-zoom';
      overlay.hidden = true;
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Product image');
      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'pdp-zoom__close';
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.textContent = '×';
      var img = document.createElement('img');
      img.alt = '';
      overlay.appendChild(closeBtn);
      overlay.appendChild(img);
      document.body.appendChild(overlay);
      function close() {
        overlay.hidden = true;
        document.body.style.overflow = '';
      }
      closeBtn.addEventListener('click', close);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay || e.target === img) close();
      });
      document.addEventListener('keydown', function (e) {
        if (!overlay.hidden && e.key === 'Escape') close();
      });
      return overlay;
    }
    stage.addEventListener('click', function (e) {
      if (mobileGalleryQuery.matches) return;
      var mediaItem = e.target.closest('.pdp__media-item');
      if (!mediaItem) return;
      var img = mediaItem.querySelector('img');
      if (!img) return;
      var ov = ensureOverlay();
      var zoomImg = ov.querySelector('img');
      var largeSrc = img.currentSrc || img.src;
      /* Prefer the largest srcset candidate if available. */
      if (img.srcset) {
        var candidates = img.srcset.split(',').map(function (s) {
          var parts = s.trim().split(/\s+/);
          return { url: parts[0], w: parseInt(parts[1], 10) || 0 };
        });
        candidates.sort(function (a, b) { return b.w - a.w; });
        if (candidates[0]) largeSrc = candidates[0].url;
      }
      zoomImg.src = largeSrc;
      zoomImg.alt = img.alt || '';
      ov.hidden = false;
      document.body.style.overflow = 'hidden';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupMobileGalleryObserver();
    setupZoom();
  });

  function selectSwatchByValue(group, value) {
    if (!group || !value) return false;
    var swatches = group.querySelectorAll('.swatch');
    var target = null;
    for (var i = 0; i < swatches.length; i++) {
      var candidate = swatches[i].getAttribute('data-value');
      if (candidate && candidate.toLowerCase() === String(value).toLowerCase()) {
        target = swatches[i];
        break;
      }
    }
    if (!target) return false;
    swatches.forEach(function (option) {
      option.classList.remove('swatch--on');
      option.setAttribute('aria-checked', 'false');
      option.setAttribute('tabindex', '-1');
    });
    target.classList.add('swatch--on');
    target.setAttribute('aria-checked', 'true');
    target.setAttribute('tabindex', '0');
    return true;
  }

  function preselectFromQueryParams() {
    var script = document.querySelector('script[data-product-variants]');
    if (!script) return;
    var variants;
    try { variants = JSON.parse(script.textContent); } catch (error) { return; }
    if (!variants || !variants.length) return;
    var params;
    try { params = new URL(window.location.href).searchParams; } catch (error) { return; }
    var variantId = params.get('variant');
    var target = null;
    if (variantId) {
      target = variants.find(function (v) { return String(v.id) === String(variantId); });
    }
    if (!target) {
      var optionParams = [];
      for (var i = 1; i <= 3; i++) {
        var p = params.get('option' + i);
        if (p) optionParams.push({ index: i - 1, value: p });
      }
      if (optionParams.length) {
        target = variants.find(function (v) {
          return optionParams.every(function (op) {
            var vopt = v.options[op.index];
            return vopt && vopt.toLowerCase() === op.value.toLowerCase();
          });
        });
      }
    }
    if (!target) return;
    document.querySelectorAll('.variant__opts').forEach(function (group) {
      var groupIndex = parseInt(group.getAttribute('data-option-index'), 10);
      if (isNaN(groupIndex)) return;
      var value = target.options[groupIndex];
      if (value) selectSwatchByValue(group, value);
    });
  }

  document.querySelectorAll('.variant__opts').forEach(function (group) {
    group.addEventListener('click', function (event) {
      var productForm = document.getElementById('product-form');
      if (productForm && productForm.getAttribute('data-submitting') === 'true') return;
      var swatch = event.target.closest('.swatch');
      if (!swatch || swatch.tagName !== 'BUTTON') return;
      group.querySelectorAll('.swatch').forEach(function (option) {
        option.classList.remove('swatch--on');
        option.setAttribute('aria-checked', 'false');
        option.setAttribute('tabindex', '-1');
      });
      swatch.classList.add('swatch--on');
      swatch.setAttribute('aria-checked', 'true');
      swatch.setAttribute('tabindex', '0');
      onVariantChange();
    });

    group.addEventListener('keydown', function (event) {
      var productForm = document.getElementById('product-form');
      if (productForm && productForm.getAttribute('data-submitting') === 'true') return;
      if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(event.key) === -1) return;
      var options = Array.prototype.slice.call(group.querySelectorAll('.swatch'));
      if (!options.length) return;
      var current = options.indexOf(document.activeElement);
      var direction = (event.key === 'ArrowRight' || event.key === 'ArrowDown') ? 1 : -1;
      var next = options[(current + direction + options.length) % options.length];
      next.focus();
      next.click();
      event.preventDefault();
    });
  });

  function getSelectedSellingPlanId() {
    var toggle = document.querySelector('[data-selling-plan-toggle="subscription"]');
    var select = document.querySelector('[data-selling-plan-select]');
    if (!select) return '';
    if (toggle && !toggle.checked) return '';
    return select.value || '';
  }

  function updateInventoryNote(match) {
    var note = document.querySelector('[data-inventory-note]');
    if (!note) return;
    var message = '';
    if (match.available && match.inventoryManagement && match.inventoryQuantity <= 0 && match.inventoryPolicy === 'continue') {
      message = note.getAttribute('data-preorder-label') || '';
    } else if (match.available && match.inventoryManagement && match.inventoryQuantity > 0 && match.inventoryQuantity <= 5) {
      var tmpl = note.getAttribute('data-low-stock-template') || '';
      message = tmpl.replace('{count}', match.inventoryQuantity);
    }
    note.textContent = message;
    note.hidden = !message;
  }

  function applyQuantityRule(match) {
    var input = document.querySelector('[name="quantity"][data-quantity-control]');
    if (!input) return;
    var rule = match.quantityRule || { min: 1, max: 0, increment: 1 };
    var min = rule.min || 1;
    var max = rule.max || 0;
    var step = rule.increment || 1;
    input.min = String(min);
    if (max > 0) { input.max = String(max); } else { input.removeAttribute('max'); }
    input.step = String(step);
    input.setAttribute('data-qty-min', String(min));
    input.setAttribute('data-qty-max', String(max));
    input.setAttribute('data-qty-step', String(step));
    var current = parseInt(input.value, 10);
    if (isNaN(current) || current < min) current = min;
    if (max > 0 && current > max) current = max;
    if (step > 1) current = min + Math.round((current - min) / step) * step;
    input.value = String(current);
    document.querySelectorAll('[data-quantity-adjust]').forEach(function (btn) {
      var direction = parseInt(btn.getAttribute('data-quantity-adjust'), 10);
      if (isNaN(direction) || direction === 0) return;
      var adjust = direction < 0 ? -step : step;
      btn.setAttribute('data-quantity-adjust', String(adjust));
    });
    var note = document.querySelector('[data-quantity-rule-note]');
    if (!note) return;
    var parts = [];
    var minTmpl = input.getAttribute('data-min-tmpl') || 'Min {count}';
    var stepTmpl = input.getAttribute('data-step-tmpl') || 'Increments of {count}';
    var maxTmpl = input.getAttribute('data-max-tmpl') || 'Max {count}';
    if (min > 1) parts.push(minTmpl.replace('{count}', min));
    if (step > 1) parts.push(stepTmpl.replace('{count}', step));
    if (max > 0) parts.push(maxTmpl.replace('{count}', max));
    if (parts.length) {
      note.textContent = parts.join(' · ');
      note.hidden = false;
    } else {
      note.textContent = '';
      note.hidden = true;
    }
  }

  function formatMoneyFallback(cents) {
    var script = document.querySelector('script[data-product-variants]');
    var currency = script ? (script.getAttribute('data-currency') || '') : '';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'USD',
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function onVariantChange() {
    var form = document.getElementById('product-form');
    var script = document.querySelector('script[data-product-variants]');
    if (!form || !script) return;
    var variants;
    try { variants = JSON.parse(script.textContent); } catch (error) { return; }

    var selected = {};
    form.querySelectorAll('.variant__opts, [data-static-option-group]').forEach(function (group) {
      var name = group.getAttribute('data-option-name');
      var active = group.querySelector('.swatch--on');
      if (name && active) selected[name] = active.getAttribute('data-value') || active.textContent.trim();
    });

    form.querySelectorAll('.variant__opts').forEach(function (group) {
      var groupIndex = parseInt(group.getAttribute('data-option-index'), 10);
      group.querySelectorAll('.swatch').forEach(function (swatch) {
        var candidate = swatch.getAttribute('data-value');
        var available = variants.some(function (variant) {
          if (!variant.available || variant.options[groupIndex] !== candidate) return false;
          return variant.options.every(function (value, optionIndex) {
            if (optionIndex === groupIndex) return true;
            var optionName = variant.optionNames[optionIndex];
            return !selected[optionName] || selected[optionName] === value;
          });
        });
        swatch.classList.toggle('swatch--unavailable', !available);
        var soldOutLabel = swatch.querySelector('[data-sold-out-label]');
        if (soldOutLabel) soldOutLabel.hidden = available;
      });
    });

    form.querySelectorAll('[data-selected-option]').forEach(function (label) {
      var position = parseInt(label.getAttribute('data-selected-option'), 10);
      if (isNaN(position)) return;
      var group = form.querySelector('[data-option-index="' + (position - 1) + '"]');
      if (!group) return;
      var name = group.getAttribute('data-option-name');
      label.textContent = name && selected[name] ? selected[name] : '';
    });

    var match = variants.find(function (variant) {
      return variant.options.every(function (value, index) {
        return selected[variant.optionNames[index]] === value;
      });
    });
    if (!match) return;

    var planId = getSelectedSellingPlanId();
    var displayPrice = match.priceFormatted;
    var displayPriceRaw = match.price;
    if (planId && match.sellingPlans && match.sellingPlans[planId]) {
      displayPrice = match.sellingPlans[planId].priceFormatted;
      displayPriceRaw = match.sellingPlans[planId].price;
    }

    var idInput = form.querySelector('[name="id"]');
    if (idInput) idInput.value = match.id;
    var price = document.querySelector('[data-product-price]');
    if (price) price.textContent = displayPrice;
    var compare = document.querySelector('[data-product-compare]');
    if (compare) {
      compare.hidden = !(match.compareAt > displayPriceRaw);
      if (!compare.hidden) compare.textContent = match.compareAtFormatted;
    }
    var saving = document.querySelector('[data-product-saving]');
    if (saving) {
      var savingAmount = Math.max(0, match.compareAt - displayPriceRaw);
      saving.hidden = savingAmount === 0;
      if (!saving.hidden) {
        var template = saving.getAttribute('data-template') || 'Save {amount}';
        var savingText = planId ? formatMoneyFallback(savingAmount) : match.savingFormatted;
        saving.textContent = template.replace('{amount}', savingText);
      }
    }
    var submit = form.querySelector('[data-atc-submit]');
    if (submit) {
      submit.textContent = match.available ? submit.getAttribute('data-add-label') + ' · ' + displayPrice : submit.getAttribute('data-ask-label');
      submit.type = match.available ? 'submit' : 'button';
      submit.disabled = false;
      submit.setAttribute('data-variant-available', String(match.available));
      submit.setAttribute('data-variant-id', match.id);
    }
    form.querySelectorAll('[data-quantity-control]').forEach(function (control) {
      control.disabled = !match.available;
    });
    applyQuantityRule(match);
    updateInventoryNote(match);
    var stickyLabel = document.querySelector('[data-sticky-variant]');
    if (stickyLabel) stickyLabel.textContent = match.options.join(' · ');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = displayPrice;
    var stickyThumb = document.querySelector('[data-sticky-thumb]');
    if (stickyThumb && match.featuredImage) {
      stickyThumb.src = match.featuredImage;
    }
    var stickySubmit = document.querySelector('[data-sticky-submit]');
    if (stickySubmit) {
      stickySubmit.textContent = match.available ? stickySubmit.getAttribute('data-add-label') : stickySubmit.getAttribute('data-ask-label');
      stickySubmit.disabled = false;
      stickySubmit.setAttribute('data-variant-available', String(match.available));
      stickySubmit.setAttribute('data-variant-id', match.id);
    }
    var dynamicCheckout = document.querySelector('[data-dynamic-checkout]');
    if (dynamicCheckout) dynamicCheckout.hidden = !match.available;
    var availabilityEnquiry = document.querySelector('[data-availability-enquiry]');
    if (availabilityEnquiry) availabilityEnquiry.hidden = match.available;
    var enquiryVariant = document.querySelector('[data-enquiry-variant]');
    if (enquiryVariant) enquiryVariant.value = match.title;
    var enquirySku = document.querySelector('[data-enquiry-sku]');
    if (enquirySku) enquirySku.value = match.sku || '';
    var enquiryVariantId = document.querySelector('[data-enquiry-variant-id]');
    if (enquiryVariantId) enquiryVariantId.value = match.id;
    var variantUrl = new URL(window.location.href);
    variantUrl.searchParams.set('variant', match.id);
    variantUrl.hash = '';
    var enquiryProductUrl = new URL(script.getAttribute('data-product-url') || variantUrl.href, window.location.origin);
    enquiryProductUrl.searchParams.set('variant', match.id);
    var enquiryUrl = document.querySelector('[data-enquiry-url]');
    if (enquiryUrl) enquiryUrl.value = enquiryProductUrl.toString();
    var enquiryBody = document.querySelector('[data-enquiry-body]');
    if (enquiryBody) enquiryBody.value = 'Availability enquiry for ' + (script.getAttribute('data-product-title') || '') + ' — ' + match.title;
    var productSku = document.querySelector('[data-product-sku]');
    if (productSku) productSku.textContent = match.sku || '';
    var productBarcode = document.querySelector('[data-product-barcode]');
    if (productBarcode) productBarcode.textContent = match.barcode || '';
    if (match.mediaId) showMedia(match.mediaId);
    window.history.replaceState(null, '', variantUrl.toString());

    var eventSource = document.querySelector('[data-product-event-source]');
    if (eventSource && typeof window.CustomEvent === 'function') {
      var selectedOptions = match.options.map(function (value, index) {
        return { name: match.optionNames[index], value: value };
      });
      eventSource.dispatchEvent(new CustomEvent('taksh:product-select', {
        bubbles: true,
        detail: {
          product: {
            id: script.getAttribute('data-product-id') || '',
            title: script.getAttribute('data-product-title') || '',
            handle: script.getAttribute('data-product-handle') || ''
          },
          selectedOptions: selectedOptions,
          variant: {
            id: 'gid://shopify/ProductVariant/' + match.id,
            title: match.title,
            availableForSale: match.available,
            price: {
              amount: String(match.priceAmount),
              currencyCode: script.getAttribute('data-currency') || ''
            },
            selectedOptions: selectedOptions
          }
        }
      }));
    }
  }

  document.querySelectorAll('[data-media-thumb]').forEach(function (button) {
    button.addEventListener('click', function () {
      showMedia(button.getAttribute('data-media-thumb'));
    });
  });

  document.querySelectorAll('[data-selling-plan-toggle]').forEach(function (toggle) {
    toggle.addEventListener('change', function () {
      var mode = toggle.getAttribute('data-selling-plan-toggle');
      var select = document.querySelector('[data-selling-plan-select]');
      if (!select) return;
      if (mode === 'subscription') {
        select.disabled = false;
        if (!select.value) {
          var first = select.querySelector('option');
          if (first) select.value = first.value;
        }
      } else {
        select.disabled = true;
      }
      onVariantChange();
    });
  });
  var sellingPlanSelect = document.querySelector('[data-selling-plan-select]');
  if (sellingPlanSelect) sellingPlanSelect.addEventListener('change', onVariantChange);

  var giftCardToggle = document.querySelector('[data-gift-card-toggle]');
  var giftCardInputs = document.querySelector('[data-gift-card-inputs]');
  if (giftCardToggle && giftCardInputs) {
    var emailInputs = giftCardInputs.querySelectorAll('input[type="email"]');
    giftCardToggle.addEventListener('change', function () {
      giftCardInputs.hidden = !giftCardToggle.checked;
      emailInputs.forEach(function (input) {
        if (giftCardToggle.checked) {
          input.setAttribute('required', 'required');
        } else {
          input.removeAttribute('required');
        }
      });
    });
  }

  var qtyInput = document.querySelector('[name="quantity"][data-quantity-control]');
  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      var min = parseInt(qtyInput.getAttribute('data-qty-min'), 10) || 1;
      var max = parseInt(qtyInput.getAttribute('data-qty-max'), 10) || 0;
      var step = parseInt(qtyInput.getAttribute('data-qty-step'), 10) || 1;
      var value = parseInt(qtyInput.value, 10);
      if (isNaN(value) || value < min) value = min;
      if (max > 0 && value > max) value = max;
      if (step > 1) value = min + Math.round((value - min) / step) * step;
      qtyInput.value = String(value);
    });
  }

  preselectFromQueryParams();
  onVariantChange();

  var addToCart = document.getElementById('atc');
  var sticky = document.querySelector('.sticky-atc');
  var footer = document.querySelector('.footer');
  if (addToCart && sticky && 'IntersectionObserver' in window) {
    sticky.hidden = true;
    var atcVisible = true;
    var footerVisible = false;
    function syncSticky() {
      var show = !atcVisible && !footerVisible;
      sticky.hidden = !show;
      document.body.classList.toggle('sticky-atc-visible', show);
      if (show) document.documentElement.style.setProperty('--sticky-atc-height', sticky.offsetHeight + 'px');
    }
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      atcVisible = entry.isIntersecting || entry.boundingClientRect.top > 0;
      syncSticky();
    }, { threshold: 0 }).observe(addToCart);
    if (footer) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        syncSticky();
      }, { threshold: 0 }).observe(footer);
    }
  } else if (sticky) {
    sticky.hidden = true;
    document.body.classList.remove('sticky-atc-visible');
  }
})();
